import React from 'react'

export const Pubfeed = () => {
    return <div className="linkby-widget" data-type="listicle"></div>
}
